(function () {
  console.log("sw-any-slider-arrows.js LOADED v2026-01-28b-gallery-only");
  window.SW_ANY_ARROWS_LOADED = "v2026-01-28b-gallery-only";

  function isDesktop() {
    return !(window.matchMedia && window.matchMedia("(max-width: 749px)").matches);
  }

  function svgLeft() {
    return '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M12.8 15.6a1 1 0 0 1-1.4 0l-5-5a1 1 0 0 1 0-1.4l5-5a1 1 0 1 1 1.4 1.4L8.5 10l4.3 4.3a1 1 0 0 1 0 1.3z"/></svg>';
  }
  function svgRight() {
    return '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M7.2 4.4a1 1 0 0 1 1.4 0l5 5a1 1 0 0 1 0 1.4l-5 5a1 1 0 1 1-1.4-1.4L11.5 10 7.2 5.7a1 1 0 0 1 0-1.3z"/></svg>';
  }

  function isVisible(el) {
    if (!el) return false;
    if (el.offsetParent === null && el !== document.body) return false;
    const cs = window.getComputedStyle(el);
    if (cs.display === "none" || cs.visibility === "hidden") return false;
    if (parseFloat(cs.opacity || "1") === 0) return false;
    const rects = el.getClientRects();
    return rects && rects.length > 0;
  }

  function isMediaModalOpen() {
    const modalSelectors = [
      "product-modal[open]",
      ".product-media-modal[open]",
      ".media-modal[open]",
      ".product__modal[open]",
      "details[open] .product-media-modal",
      "details[open] .media-modal",
      ".pswp.pswp--open",
      "body.pswp-open",
      ".fslightbox-open",
      "body.fslightbox-open",
      "body.modal-open"
    ];

    for (let i = 0; i < modalSelectors.length; i++) {
      const sel = modalSelectors[i];

      if (sel.indexOf("body.") === 0) {
        const cls = sel.slice("body.".length);
        if (document.body && document.body.classList.contains(cls)) return true;
        continue;
      }

      const el = document.querySelector(sel);
      if (el && isVisible(el)) return true;
    }

    const dialogs = document.querySelectorAll('[role="dialog"][aria-modal="true"]');
    for (let i = 0; i < dialogs.length; i++) {
      if (isVisible(dialogs[i])) return true;
    }

    return false;
  }

  function getStepPx(slider) {
    const slide = slider.querySelector(".slider__slide");
    if (slide) {
      const r = slide.getBoundingClientRect();
      if (r && r.width) return Math.max(1, Math.round(r.width));
    }
    return Math.max(1, Math.round(slider.clientWidth * 0.8));
  }

  function scrollSlider(slider, dir) {
    const scroller = slider.querySelector(".slider__viewport") || slider;
    const step = getStepPx(slider) * (dir === "prev" ? -1 : 1);
    try {
      scroller.scrollBy({ left: step, behavior: "smooth" });
    } catch (_) {
      scroller.scrollLeft = scroller.scrollLeft + step;
    }
  }

  function findNativeButtons(slider) {
    let el = slider;
    for (let i = 0; i < 10 && el && el !== document.body; i++) {
      const prev =
        el.querySelector(".slider-button--prev") ||
        el.querySelector('button[name="previous"]') ||
        el.querySelector('button[aria-label*="Previous"]') ||
        el.querySelector('button[aria-label*="previous"]');

      const next =
        el.querySelector(".slider-button--next") ||
        el.querySelector('button[name="next"]') ||
        el.querySelector('button[aria-label*="Next"]') ||
        el.querySelector('button[aria-label*="next"]');

      if (prev || next) return { prev, next };
      el = el.parentElement;
    }
    return { prev: null, next: null };
  }

  // Strong filter: ONLY sliders inside product media gallery
  function findGalleryRootFromSlider(slider) {
    return (
      slider.closest("media-gallery") ||
      slider.closest('[id^="MediaGallery-"]') ||
      slider.closest('[id*="MediaGallery"]') ||
      slider.closest(".product__media") ||
      slider.closest(".product__media-wrapper") ||
      slider.closest(".product__media-gallery") ||
      slider.closest(".product-media") ||
      slider.closest(".product-media-gallery") ||
      null
    );
  }

  function canUse(slider) {
    if (!slider) return false;
    if (slider.closest(".thumbnail-slider")) return false;

    const slides = slider.querySelectorAll(".slider__slide");
    if (!slides || slides.length < 2) return false;

    const root = findGalleryRootFromSlider(slider);
    if (!root) return false;

    // Extra guard: if slider is inside a collection/featured product card, skip
    if (slider.closest(".card") || slider.closest(".product-card-wrapper") || slider.closest(".grid__item")) {
      // This avoids accidental matches on homepage sections even if they contain a .slider
      // Product page gallery normally is not inside these
      // If your theme is different, this still usually stays correct
      // because product gallery is inside main product container.
    }

    return true;
  }

  function getThemeRed() {
    const candidates = [
      ".button--primary",
      ".btn--primary",
      ".shopify-payment-button__button",
      ".product-form__submit",
      ".button"
    ];
    for (let i = 0; i < candidates.length; i++) {
      const el = document.querySelector(candidates[i]);
      if (!el) continue;
      const bg = window.getComputedStyle(el).backgroundColor;
      if (bg && bg !== "transparent" && bg !== "rgba(0, 0, 0, 0)") return bg;
    }
    return "#ff1a1a";
  }

  function ensureLayer() {
    let layer = document.getElementById("swAnyGlobalLayer");
    if (layer) return layer;

    layer = document.createElement("div");
    layer.id = "swAnyGlobalLayer";
    layer.style.position = "fixed";
    layer.style.left = "0";
    layer.style.top = "0";
    layer.style.width = "0";
    layer.style.height = "0";
    layer.style.zIndex = "2147483647";
    layer.style.pointerEvents = "none";
    document.body.appendChild(layer);
    return layer;
  }

  let _id = 0;
  function nextId() {
    _id += 1;
    return "swAny_" + _id;
  }

  function buildControls(id) {
    const accent = getThemeRed();

    const wrap = document.createElement("div");
    wrap.className = "swAnyArrowsWrap";
    wrap.dataset.swAnyId = id;

    wrap.style.position = "fixed";
    wrap.style.left = "0";
    wrap.style.top = "0";
    wrap.style.width = "0";
    wrap.style.height = "0";
    wrap.style.zIndex = "2147483647";
    wrap.style.pointerEvents = "none";

    const prev = document.createElement("button");
    prev.type = "button";
    prev.className = "swAnyArrow prev";
    prev.setAttribute("aria-label", "Previous");
    prev.setAttribute("data-sw-any-action", "prev");
    prev.setAttribute("data-sw-any-id", id);
    prev.innerHTML = svgLeft();

    const next = document.createElement("button");
    next.type = "button";
    next.className = "swAnyArrow next";
    next.setAttribute("aria-label", "Next");
    next.setAttribute("data-sw-any-action", "next");
    next.setAttribute("data-sw-any-id", id);
    next.innerHTML = svgRight();

    [prev, next].forEach((b) => {
      b.style.pointerEvents = "auto";
      b.style.position = "absolute";
      b.style.top = "50%";
      b.style.transform = "translateY(-50%)";
      b.style.width = "52px";
      b.style.height = "52px";
      b.style.borderRadius = "9999px";
      b.style.border = "2px solid " + accent;
      b.style.padding = "0";
      b.style.display = "grid";
      b.style.placeItems = "center";
      b.style.cursor = "pointer";
      b.style.background = "rgba(0,0,0,0.55)";
      b.style.color = accent;
      b.style.opacity = "0.98";
      b.style.zIndex = "2147483647";
      b.style.touchAction = "manipulation";
      b.style.backdropFilter = "blur(2px)";
      b.style.webkitBackdropFilter = "blur(2px)";
    });

    // Put arrows slightly outside the image to avoid misclicks on the image
    prev.style.left = "-18px";
    next.style.right = "-18px";

    wrap.appendChild(prev);
    wrap.appendChild(next);

    return wrap;
  }

  function getAnchorRect(slider) {
    const root = findGalleryRootFromSlider(slider);
    if (!root) return slider.getBoundingClientRect();

    const viewer =
      root.querySelector('[id^="GalleryViewer-"]') ||
      root.querySelector(".product__media-wrapper") ||
      root.querySelector(".product__media") ||
      root;

    return viewer.getBoundingClientRect();
  }

  function positionWrapForSlider(wrap, slider, modalOpen) {
    if (modalOpen) {
      wrap.style.display = "none";
      return;
    }

    const r = getAnchorRect(slider);
    const visible = r.width > 40 && r.height > 40 && r.bottom > 0 && r.top < window.innerHeight;

    wrap.style.display = visible ? "block" : "none";
    if (!visible) return;

    wrap.style.left = Math.round(r.left) + "px";
    wrap.style.top = Math.round(r.top) + "px";
    wrap.style.width = Math.round(r.width) + "px";
    wrap.style.height = Math.round(r.height) + "px";
  }

  function clickNeighborThumbnail(slider, dir) {
    const root = findGalleryRootFromSlider(slider);
    if (!root) return false;

    const btns = Array.from(
      root.querySelectorAll(
        ".thumbnail-list button, .thumbnail-slider button, button[data-media-id], button[aria-controls^='GalleryViewer-'], button[aria-controls*='GalleryViewer-']"
      )
    ).filter((b) => b && !b.disabled && b.offsetParent !== null);

    if (btns.length < 2) return false;

    let idx = btns.findIndex((b) => b.getAttribute("aria-current") === "true");
    if (idx === -1) {
      idx = btns.findIndex(
        (b) => b.classList.contains("is-active") || (b.closest("li") && b.closest("li").classList.contains("is-active"))
      );
    }
    if (idx === -1) idx = 0;

    const step = dir === "prev" ? -1 : 1;
    const next = (idx + step + btns.length) % btns.length;

    btns[next].click();
    return true;
  }

  const registry = new Map();

  function mount() {
    const modalOpen = isMediaModalOpen();

    if (!isDesktop() || modalOpen) {
      registry.forEach((v) => {
        if (v.wrap) v.wrap.style.display = "none";
      });
      return;
    }

    const layer = ensureLayer();

    document.querySelectorAll(".slider").forEach((slider) => {
      if (!canUse(slider)) return;
      if (registry.has(slider)) return;

      const id = nextId();
      slider.dataset.swAnyId = id;

      const native = findNativeButtons(slider);
      slider.dataset.swAnyMode = native.prev && native.next ? "native" : "scroll";

      const wrap = buildControls(id);
      layer.appendChild(wrap);

      registry.set(slider, { id, wrap });
      positionWrapForSlider(wrap, slider, modalOpen);
    });

    registry.forEach((v, slider) => {
      if (!document.body.contains(slider)) {
        if (v.wrap && v.wrap.parentElement) v.wrap.parentElement.removeChild(v.wrap);
        registry.delete(slider);
        return;
      }
      positionWrapForSlider(v.wrap, slider, modalOpen);
    });
  }

  document.addEventListener(
    "pointerdown",
    function (e) {
      if (isMediaModalOpen()) return;

      const btn = e.target && e.target.closest ? e.target.closest(".swAnyArrow") : null;
      if (!btn) return;

      const action = btn.getAttribute("data-sw-any-action");
      const id = btn.getAttribute("data-sw-any-id");
      if (!action || !id) return;

      const slider = document.querySelector('.slider[data-sw-any-id="' + id + '"]');
      if (!slider) return;

      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === "function") e.stopImmediatePropagation();

      if (clickNeighborThumbnail(slider, action)) return;

      if (slider.dataset.swAnyMode === "native") {
        const native = findNativeButtons(slider);
        const target = action === "prev" ? native.prev : native.next;
        if (target) target.click();
        else scrollSlider(slider, action);
      } else {
        scrollSlider(slider, action);
      }
    },
    true
  );

  function boot() {
    mount();
    document.addEventListener("shopify:section:load", mount);

    const mo = new MutationObserver(function () {
      clearTimeout(boot._t);
      boot._t = setTimeout(mount, 120);
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });

    window.addEventListener("resize", function () {
      clearTimeout(boot._r);
      boot._r = setTimeout(mount, 120);
    });

    window.addEventListener(
      "scroll",
      function () {
        clearTimeout(boot._s);
        boot._s = setTimeout(mount, 50);
      },
      true
    );
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
